var ContactModelFactory,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('models/contact/ContactModel',["evertrue", "underscore", "backbone", "ET/ETModel", "collections/contact/PropertyCollection", "helpers/contact-mixin"], ContactModelFactory = function(EverTrue, _, Backbone, ETModel, PropertyCollection, ContactHelper) {
  var ContactModel;
  return ContactModel = (function(_super) {
    __extends(ContactModel, _super);

    function ContactModel() {
      return ContactModel.__super__.constructor.apply(this, arguments);
    }

    ContactModel.prototype.urlRoot = "contacts/v1/contacts";

    ContactModel.prototype.saveDirectory = function() {
      if (EverTrue.Directory) {
        return EverTrue.Directory.add(this, {
          merge: true
        });
      }
    };

    ContactModel.prototype.isEditable = function(array) {
      if (_.findWhere(array, {
        update_source: "console"
      })) {
        return true;
      } else {
        return false;
      }
    };

    ContactModel.prototype.getSchema = function() {
      var roles;
      roles = [];
      if (EverTrue.Organization) {
        roles = _.map(EverTrue.Organization.get("roles"), function(role) {
          return {
            val_display: role.name,
            val: role.id
          };
        });
      }
      return ContactHelper.getSchema(roles);
    };

    ContactModel.prototype.getTemplate = function(options, callback) {
      var fields, model, tmplData, user, _ref;
      model = this.toJSON();
      tmplData = ContactHelper.setBasicTemplate(model);
      if (_.isEmpty(model.properties)) {
        tmplData.b_editable = true;
      } else {
        tmplData.b_editable = this.isEditable(model.properties);
      }
      if (model.matched && model.matched.user) {
        user = model.matched.user;
        tmplData.user_email = (user && user.email ? user.email : "");
      }
      tmplData.properties = [_.clone(tmplData)];
      tmplData.customs = [];
      _.each(model, (function(_this) {
        return function(val, key) {
          var props_not_to_render;
          props_not_to_render = ["properties", "linkedin", "linkedin_positions", "scores"];
          if (_.isArray(val) && !_.contains(props_not_to_render, key)) {
            return _.each(val, function(obj) {
              var custom_obj, profileObj;
              profileObj = ContactHelper.setContactObj(key, obj);
              if (_.isEmpty(profileObj)) {
                return;
              }
              if (profileObj.is_custom) {
                custom_obj = _.findWhere(tmplData["customs"], {
                  name: profileObj.name
                });
                if (!custom_obj) {
                  profileObj["value"] = [profileObj.value];
                  return tmplData["customs"].push(profileObj);
                } else {
                  return custom_obj["value"].push(profileObj.value);
                }
              } else {
                profileObj["id"] = obj.id;
                profileObj["b_editable"] = _this.isEditable(obj.properties);
                tmplData[key] = tmplData[key] || [];
                return tmplData[key].push(profileObj);
              }
            });
          }
        };
      })(this));
      if (((_ref = tmplData["customs"]) != null ? _ref.length : void 0) > 0 && (options != null ? options.loadCustomFieldLabels : void 0)) {
        fields = new PropertyCollection();
        return fields.fetch({
          success: function() {
            _.each(tmplData["customs"], function(obj) {
              var field, label;
              field = fields.findWhere({
                name: obj.name
              });
              label = field != null ? field.getLabel(obj.name) : void 0;
              obj.label = label ? label : obj.name;
              return obj.enabled_state = field != null ? field.getEnabledState(obj.name) : void 0;
            });
            if (_.isFunction(callback)) {
              return callback(tmplData);
            } else {
              return tmplData;
            }
          },
          error: function() {
            if (_.isFunction(callback)) {
              return callback(tmplData);
            } else {
              return tmplData;
            }
          }
        });
      } else {
        if (_.isFunction(callback)) {
          return callback(tmplData);
        } else {
          return tmplData;
        }
      }
    };

    ContactModel.prototype.createContact = function(opts) {
      var email, options, roles;
      roles = this.get("role");
      email = this.get("identity_email");
      options = {
        type: "POST",
        url: "contacts/v1/contacts",
        params: {
          oid: EverTrue.Organization.get("id"),
          properties: []
        },
        success: (function(_this) {
          return function(response) {
            EverTrue.alertView.alert("success", {
              message: "Contact Created"
            });
            _this.set({
              id: response.id
            });
            return _this.saveRolesOverride(response, function() {
              return EverTrue.vent.trigger("reloadPage");
            });
          };
        })(this)
      };
      _.extend(options, opts);
      _.each(this.attributes, function(value, key) {
        if (!_.contains(["identity_email", "role"], key) && !_.isEmpty(value)) {
          return options.params.properties.push({
            name: key,
            value: value
          });
        }
      });
      if (email) {
        options.params.identities = [
          {
            type: "email",
            value: email
          }
        ];
        options.params.emails = [
          {
            object_type: "email",
            properties: [
              {
                name: "email",
                value: email
              }
            ]
          }
        ];
      }
      roles = (_.isArray(roles) ? roles : [roles]);
      roles = _.map(roles, function(role) {
        return parseInt(role, 10);
      });
      this.set({
        role: roles
      });
      options.params.roles = this.get("role");
      return $.when(EverTrue.api(options, this));
    };

    ContactModel.prototype.updateContact = function(params, done, update_role) {
      var options;
      options = {
        url: "contacts/v1/contacts/" + params.id + "/",
        type: "PUT",
        params: params,
        success: (function(_this) {
          return function(resp) {
            EverTrue.alertView.alert("success", {
              message: "Record Updated"
            });
            if (_.isFunction(done)) {
              done();
            }
            if ((update_role != null ? update_role.length : void 0) > 0) {
              _this.set("role", update_role);
              return _this.saveRolesOverride(resp, function() {
                return EverTrue.vent.trigger("reloadPage");
              });
            } else {
              return EverTrue.vent.trigger("reloadPage");
            }
          };
        })(this),
        error: function() {
          if (_.isFunction(done)) {
            return done();
          }
        }
      };
      return EverTrue.api(options, this);
    };

    ContactModel.prototype.saveRolesOverride = function(contact, done) {
      var options, roles;
      roles = this.get("role");
      options = {
        type: "PUT",
        url: "contacts/v1/roles/override/contact/" + contact.id + "/",
        params: {
          updated_at: contact.updated_at,
          roles_override: roles
        },
        success: function(response) {
          if (_.isEmpty(_.difference(response.roles_override, roles))) {
            EverTrue.alertView.alert("success", {
              message: "Roles Updated"
            });
            if (_.isFunction(done)) {
              return done();
            }
          } else {
            EverTrue.alertView.alert("error", {
              message: "There was a problem updating the roles."
            });
            return Raven.captureMessage("Roles_override did not update correctly");
          }
        }
      };
      return EverTrue.api(options, this);
    };

    ContactModel.prototype.deleteContact = function() {
      var contact_id, msg, options;
      msg = "Contact Deleted";
      contact_id = this.get("id");
      options = {
        url: "contacts/v1/contacts/" + contact_id + "/",
        type: "DELETE",
        success: function() {
          return EverTrue.alertView.alert("succes", {
            message: msg
          });
        },
        complete: function(resp) {
          return EverTrue.alertView.alert("succes", {
            message: msg
          });
        },
        error: function(resp) {
          return alert("Error: Contact not Deleted");
        }
      };
      return EverTrue.api(options, this);
    };

    return ContactModel;

  })(ETModel);
});

//# sourceMappingURL=ContactModel.js.map
;
